import { useRuntimeConfig } from '#imports'
import type { RouteRecordRaw } from 'vue-router'

import { ROUTE_NAMES as DASHBOARD_ROUTE_NAMES } from '~/scopes/dashboard/constants'

import { GUEST } from './route-names'

export default (): RouteRecordRaw[] => {
  const { FF_ENABLE_GUEST_MY_ORDERS } = useRuntimeConfig().public

  return [
    {
      name: GUEST.ORDERS,
      path: 'guest/orders',
      component: () =>
        import('~/scopes/guest/pages/guest-orders/GuestOrders.vue'),
      meta: {
        owners: ['bot-squad-sales-customer-care-front'],
        routeExists: () => FF_ENABLE_GUEST_MY_ORDERS === true,
        auth: {
          mode: ['guest'],
          redirection: {
            authenticated: {
              name: DASHBOARD_ROUTE_NAMES.DASHBOARD.MY_ORDERS.SELF,
            },
          },
        },
        tracking: { contentGroup: 'Account' },
        shoppingAssistant: { enabled: false },
      },
    },
  ]
}
